import { DateTime } from 'ts-luxon';

import { ExtendedWarranty } from '@shure/cloud/shared/models/devices';

import { ExtendedWarrantyFragment } from '../graphql/generated/cloud-sys-api';

export function mapExtendedWarrantyFromSysApi(extendedWarranty: ExtendedWarrantyFragment | null): ExtendedWarranty {
	return extendedWarranty?.warranty
		? {
				warranty: {
					expirationDate: DateTime.fromISO(extendedWarranty.warranty.expirationDate, { setZone: true })
				}
			}
		: {};
}
